export const headCell = [
    {
      id: "Date",
      label: "Date",
      width: "100px",
      disableSort: true,
    },
    {
      id: "Account",
      label: "Account",
      width: "150px",
      disableSort: true,
    },
    {
      id: "VoucherType",
      label: "Voucher Type",
      width: "130px",
      disableSort: true,
    },
    {
      id: "VoucherNumber",
      label: "Voucher Number",
      width: "130px",
      disableSort: true,
    },
  
    {
      id: "debit",
      label: "Debit (₹)",
      width: "100px",
      disableSort: true,
      numeric: true,
    },
    {
      id: "credit",
      label: "Credit (₹)",
      width: "100px",
      disableSort: true,
      numeric: true,
    },
    {
      id: "Balance",
      label: "Balance (₹)",
      width: "100px",
      disableSort: true,
      numeric: true,
    },
    {
      id: "remarks",
      label: "Narration",
      // width: "80px",
      maxWidth: "450px",
      disableSort: true,
    },
  ];